import React from 'react';
// Updated 2026-03-04: added CreditCard, BarChart3 for billing pages
import {
  AlertCircle, AlertTriangle, ArrowDown, ArrowLeft, ArrowRight,
  BarChart3, Bell, Box, BoxSelect, Building2,
  Calendar, Check, CheckCircle, CheckCircle2, CheckSquare,
  CircleCheck,
  ChevronDown, ChevronRight, ChevronsUpDown, ChevronUp, Circle,
  ClipboardList, Clock, Copy, CreditCard,
  Database, DollarSign, Download,
  Edit, Edit2, ExternalLink, Eye,
  FileSearch, FileText, FileX, Filter, FolderOpen,
  Hammer, HelpCircle, History, Home,
  Info,
  Layers, LayoutDashboard, Lightbulb, Link, List, ListChecks, Loader2, LogIn, LogOut,
  Menu,
  Minus,
  Package, PackageCheck, PackagePlus, PackageX, Play, Plus, PlusCircle, Printer,
  RefreshCw, RotateCcw,
  Save, ScanLine, Search, Shield, ShoppingBag, ShoppingCart,
  Target, Trash2, TrendingDown, TrendingUp, Trophy,
  Upload, User, UserPlus, UserX, Users,
  Wifi, Wrench,
  X, XCircle,
} from 'lucide-react';

// Explicit icon map — only icons actually used in the app.
// To add a new icon: import it above, then add it to this object.
const iconMap = {
  AlertCircle, AlertTriangle, ArrowDown, ArrowLeft, ArrowRight,
  BarChart3, Bell, Box, BoxSelect, Building2,
  Calendar, Check, CheckCircle, CheckCircle2, CheckSquare,
  CircleCheck,
  ChevronDown, ChevronRight, ChevronsUpDown, ChevronUp, Circle,
  CreditCard,
  ClipboardList, Clock, Copy,
  Database, DollarSign, Download,
  Edit, Edit2, ExternalLink, Eye,
  FileSearch, FileText, FileX, Filter, FolderOpen,
  Hammer, HelpCircle, History, Home,
  Info,
  Layers, LayoutDashboard, Lightbulb, Link, List, ListChecks, Loader2, LogIn, LogOut,
  Menu,
  Minus,
  Package, PackageCheck, PackagePlus, PackageX, Play, Plus, PlusCircle, Printer,
  RefreshCw, RotateCcw,
  Save, ScanLine, Search, Shield, ShoppingBag, ShoppingCart,
  Target, Trash2, TrendingDown, TrendingUp, Trophy,
  Upload, User, UserPlus, UserX, Users,
  Wifi, Wrench,
  X, XCircle,
};

function Icon({
    
    name,
    size = 24,
    color = "currentColor",
    className = "",
    strokeWidth = 2,
    ...props
}) {
    const IconComponent = iconMap[name];

    if (!IconComponent) {
        return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
    }

    return <IconComponent
        size={size}
        color={color}
        strokeWidth={strokeWidth}
        className={className}
        {...props}
    />;
}
export default Icon;